import { gql } from '@apollo/client';

export const CREATE_DEPENDENT = gql`
  mutation CreateDependent($dependent: DependentDtoInput) {
      createDependent(dependent: $dependent) {
        id
      }
    }
`;
